import script from "./WelcomeLanding2.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeLanding2.vue?vue&type=script&setup=true&lang=js"

import "@/assets/landing-page/assets/css/icons.css?vue&type=style&index=0&id=04243a98&lang=css&scoped=true&external"
import "@/assets/landing-page/assets/css/layout.css?vue&type=style&index=1&id=04243a98&lang=css&scoped=true&external"
import "@/assets/landing-page/assets/css/hero.scss?vue&type=style&index=2&id=04243a98&lang=scss&scoped=true&external"
import "@/assets/landing-page/assets/css/blocks.css?vue&type=style&index=3&id=04243a98&lang=css&scoped=true&external"
import "./WelcomeLanding2.vue?vue&type=style&index=4&id=04243a98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04243a98"]])

export default __exports__